module.exports = __webpack_public_path__ + "images/emoji/vertical_traffic_light.ce02e2ebe04808e741cd.png";